import { logger as garnishLogger } from '@garnish/logger';

export const log = garnishLogger.extend('LAUNCH_DARKLY_INTEGRATION');
